import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        iconWrapper: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        icon: {
            color: theme.palette.secondary[600],
            height: '20px !important',
            width: '20px !important',
        },
        'icon &:first-of-type': {
            marginRight: '-5px',
        },
        link: {
            textDecoration: 'none !important',
            padding: '0px !important',
        },
    }
})

export default useStyles
